import { useState } from "react";
import axios from "axios";

function KatalogAdd({ reload }) {
  const [form, setForm] = useState({ naslov: "", opis: "" });
  const [image, setImage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("naslov", form.naslov);
    data.append("opis", form.opis);
    data.append("image", image);

    try {
      await axios.post("http://localhost:5000/api/katalog", data);
      alert("Katalog item added");
      if (reload) reload();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container py-5 d-flex justify-content-center">
      <form
        onSubmit={handleSubmit}
        className="p-4 shadow-lg rounded-4 bg-white"
        style={{ width: "100%", maxWidth: "500px" }}
      >
        <h3 className="text-center mb-4 fw-bold">Dodaj stavku u katalog</h3>

        <div className="mb-3">
          <label className="form-label fw-semibold">Naslov</label>
          <input
            type="text"
            className="form-control form-control-lg"
            placeholder="Unesite naslov"
            onChange={(e) =>
              setForm({ ...form, naslov: e.target.value })
            }
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-semibold">Opis</label>
          <textarea
            className="form-control"
            rows="4"
            placeholder="Unesite opis"
            onChange={(e) =>
              setForm({ ...form, opis: e.target.value })
            }
            required
          />
        </div>

        <div className="mb-4">
          <label className="form-label fw-semibold">Slika</label>
          <input
            type="file"
            className="form-control"
            onChange={(e) => setImage(e.target.files[0])}
          />
        </div>

        <button
          type="submit"
          className="btn btn-dark w-100 py-2 fw-semibold"
        >
          Dodaj
        </button>
      </form>
    </div>
  );
}

export default KatalogAdd;